import { AfterViewInit, Component, ElementRef, HostListener, ModuleWithProviders, NgZone, ViewChild } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import swal from "sweetalert2";
import { ApidataService } from '../apidata.service';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { FooterComponent } from '../footer/footer.component';
import { MetaTagService } from '../meta-tag.service';
import { ChangeDetectorRef } from '@angular/core';
import { environment, GINConstants } from '../../environments/environments';
import { FeedbackComponent } from '../feedback/feedback.component';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { PremiumComponent } from "../premium/premium.component";
import { PremiumModalStartupComponent } from '../premium-modal/premium-modal.component';
import { AboutUsComponent } from "../about-us/about-us.component";
declare var $: any;
declare var Dropbox: any;
declare var gapi: any;
declare var google: any;
declare var FB: any;
declare var window: any;
@Component({
  selector: 'app-textdetector',
  standalone: true,
  imports: [HeaderComponent, CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule,
    NgCircleProgressModule, FooterComponent, FeedbackComponent, IconsFreeToolsComponent, PremiumComponent,
    PremiumModalStartupComponent, AboutUsComponent],
  providers: [ApidataService, (NgCircleProgressModule.forRoot({
    radius: 100,
    outerStrokeWidth: 16,
    innerStrokeWidth: 8,
    outerStrokeColor: '#78C000',
    innerStrokeColor: '#C7E596',
    animationDuration: 300,
  }) as ModuleWithProviders<NgCircleProgressModule>).providers!,],
  templateUrl: './textdetector.component.html',
  styleUrl: './textdetector.component.css'
})
export class TextdetectorComponent implements AfterViewInit{

  error: boolean = false;
  public getterrible: boolean = false;
  public badvalue: boolean = false;
  public goodvalue: boolean = false;
  public okayvalue: boolean = false;
  public amzaingvalue: boolean = false;
  public showmsg: boolean = false;
  success: boolean = false;
  public showfeedbackloader: boolean = false;
  public eFsubIF: boolean = false;
  public loaderAlert: boolean = false;
  public showeditorplaceholder: boolean = false;
  public gotresponse: boolean = false;
  ifsub: boolean = false;
  public cleartxtbtn: boolean = false;
  shouldShowButton: boolean = false;
  showParagraph: boolean = true;
  public mobilescreen: boolean = false;
  public responseformodbile: boolean = false;
  recaptcha_message = ""
  got_recpatcha: boolean = false;
  captchaToken: string | null = null; 



  errorAlerts;
  successAlert;
  dangerAlerts;
  char_count;



  public esubTextExp: string = '';
  public esubText2Exp: string = '';
  feedbackValue: string = '';
  public color: string = 'black';
  public esubText: string = '';
  public esubText2: string = '';
  selectedTab: string = 'tab1';
  activeTab: string = '';
  editortxt = '';


  public form_message: any;
  public form_email: any;
  eFsubText2: any;



  selectedValue: number;
  count = 5;
  word_count = 0;
  human_score = 0;
  ai_score = 0;


  stars: number[] = [1, 2, 3, 4, 5];
  public clientId = "859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com";

  public scope = [
    "profile",
    "email",
    "https://www.googleapis.com/auth/drive.file", 
  ].join(" ");
  public pickerApiLoaded = false;
  public oauthToken?: any;


  constructor(private cdr: ChangeDetectorRef, private webservices: ApidataService, private router: Router, private https: HttpClient,
    private metaService: MetaTagService) { }
  @ViewChild("text") text: ElementRef;

  @ViewChild("fileInput") fileInput;



  ngOnInit(): void {
  
    // if (this.captchaVisible) {
    //   this.loadAndRenderTurnstile();
    // }

 

    this.metaService.updateTags("AI Content Detector | AI Text Checker Tool Bard, GPT3 & GPT4 ",
      "Grammar In's advanced AI content detector tool can accurately identifies if content is generated ChatGPT, GPT-4, Bard & Claude. Detect the AI content for free."
      , "https://www.grammarin.com/ai-content-detector",
      "https://www.grammarin.com/assets/images/OG-Images/AI Text Detector.png",
      'AI Text Detector');

    $(".tab_content").hide();
    $(".tab_content:first").show();

    
    $("ul.tabs li").click(function () {

      $(".tab_content").hide();
      var activeTab = $(this).attr("rel");
      $("#" + activeTab).fadeIn();

      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

      $(".tab_drawer_heading").removeClass("d_active");
      $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

    
    });
    $(".tab_container").css("min-height", function () {
      return $(".tabs").outerHeight() + 50;
    });
  
    $(".tab_drawer_heading").click(function () {

      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel");
      $("#" + d_activeTab).fadeIn();

      $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");

      $("ul.tabs li").removeClass("active");
      $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
    });

    this.activeTab = 'q5';
  }
  recaptchaWidgetId: number | undefined;




  ////// hidden recaptcha strat

  captchaVisible: boolean = false;  
  isCaptchaVerified: boolean = false;  
  recaptchaMessage: string = '';  


  handleButtonClick(): void {
    if (this.loaderAlert) {
      return;
    }
    $("#editor").find("span").contents().unwrap();
    this.char_count = $("#editor").text().length;
    this.word_count = $("#editor").text().trim().split(/\s+/).length;


    if (this.word_count >= 10 && this.word_count <= 1000) {
      this.showCaptchaModal();  
    } else {
      this.showAlert("Enter 10 to 1000 words to Check AI Text Detector.", "");
    }
  }

  // Show CAPTCHA modal and handle dynamic loading/rendering of CAPTCHA
  showCaptchaModal(): void {
    if (!this.captchaVisible) {
      this.captchaVisible = true; 
      this.cdr.detectChanges();    
      this.loadAndRenderTurnstile();  
    } else {
      this.recaptchaMessage = 'Please complete the CAPTCHA.'; 
      this.color = '#721c24';  
    }
  }


  textfromAI() {
    if (localStorage.getItem('editorValueAI')) {
      this.showParagraph = false;
    }
    setTimeout(() => {
      if (localStorage.getItem('editorValueAI')) {
        this.editortxt = localStorage.getItem('editorValueAI');
        this.char_count = this.editortxt.length;
        this.word_count = this.editortxt.trim().split(/\s+/).length;
        localStorage.removeItem('editorValueAI');

        if (this.editortxt != null && this.editortxt.length !== 0) {
          this.textDivRef.nativeElement.innerHTML = this.editortxt;
        }
      }
    }, 1000);
  }

  // Load and render Turnstile CAPTCHA
  loadAndRenderTurnstile(): void {
    if (typeof window['turnstile'] === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => this.renderTurnstile();
      script.onerror = () => 
        // console.error('Failed to load Turnstile script.');
      document.body.appendChild(script);
    } else {
      this.renderTurnstile();
    }
  }

  // Render Turnstile CAPTCHA in modal
  renderTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (!containerElement) {
      // console.error('Container element not found.');
      return;
    }

    window['turnstile'].render(containerElement, {
      sitekey: environment.CaptchaKey, 
      size: 'normal',
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
    // console.log('Turnstile rendered successfully.');
  }

  // Callback for successful CAPTCHA verification
  onTurnstileSuccess(token: string): void {
    // console.log('Turnstile token received:', token);
    this.captchaToken = token;
    this.isCaptchaVerified = true;  
    this.captchaVisible = false;   
    this.recaptchaMessage = '';    
    this.checkairesponse();  
  }

  // Callback for CAPTCHA error (if verification fails)
  onTurnstileError(): void {
    // console.error('Turnstile error occurred.');
    this.captchaToken = null;
    this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
    this.color = '#721c24'; 
  }

  // Reset CAPTCHA in case of error or retry
  resetTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (typeof window['turnstile'] !== 'undefined') {
      window['turnstile'].reset(containerElement);
      // console.log('Turnstile CAPTCHA reset.');
    } else {
      // console.error('Turnstile library not loaded.');
    }
  }

  ///// recaptcha end

  toggleTab(tabId: string): void {
    if (this.activeTab === tabId) {
      this.activeTab = '';
    } else {
      this.activeTab = tabId;
    }
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  //   // feedback

  countStar(star) {
    this.selectedValue = star;

  }


  public eFormSubmission(event: any) {
    event.preventDefault();
    this.eFsubIF = false
    $("#eFsubText2").hide();
    this.form_email = $('#form_email').val();
    this.form_message = $('#form_message').val();
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (this.form_message.length === 0) {
      this.color = '#721c24';
      this.eFsubText2 = 'Please provide the required fields';
      $('#form_message').val('').css("border-color", "red");
      this.eFsubIF = true
      $("#eFsubText2").show();
      setTimeout(function () {
        $("#eFsubText2").hide();
        $('#form_message').css("border-color", "#08ba9c");
        this.eFsubIF = false
      }, 3000);
    }
    else {
      this.showfeedbackloader = true;
      const headers = new HttpHeaders({
        'Authorization': environment.AuthorizationGIN,
      });
      this.https.post(environment.API_URL + '/api/feedbackForm', { 'email': this.form_email, 'comment': this.form_message, 'page_name': "home", 'emotion': this.selectedValue }, { headers }).subscribe(
        (response) => {
          this.showfeedbackloader = false
          this.color = 'green';
          this.eFsubText2 = 'Form Submitted Successfully!';
          this.eFsubIF = true
          $("#eFsubText2").show();
          setTimeout(function () {
            $("#eFsubText2").hide();
            this.eFsubIF = false
          }, 3000);
          $('#form_email').val('').css("border-color", "#08ba9c");
          $('#form_message').val('').css("border-color", "#08ba9c");
        },
        (error) => {
          // console.error(error);
        }
      );

    }
  }

  checkMail() {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    this.form_email = $('#form_email').val();
    if (
      reg.test(this.form_email) === false
    ) {
      this.color = '#721c24';
      this.dangerAlerts = 'Please provide correct Email';
      $('#form_email').val('').css("border-color", "red");
      this.ifsub = true
      $("#dangerAlerts").show();
      setTimeout(function () {
        $("#dangerAlerts").hide();
        $('#form_email').css("border-color", "#08ba9c");
        this.ifsub = false
      }, 3000);
    }
  }

  pasteText(): void {
    navigator.clipboard.readText().then(pastedText => {
      document.execCommand('insertText', false, pastedText);
      $("#editor").html(pastedText);
      this.char_count = $("#editor").text().length;
      this.word_count = $("#editor").text().trim().split(" ").length;
      this.showParagraph = false;
    }).catch(err => {
      // console.error('Failed to read clipboard contents: ', err);
    });
  }
  sampletext() {
    $("#editor").html("We all are aware of the fact that plagiarism can destroy our careers and websites' credibility. Suppose you have detected that some proportion of your text is plagiarized. In that case, you can opt to use the best article rewriter to make your plagiarized sentences and display their plagiarism-free version in a matter of seconds. It means that it's not only wasted an hour or more trying to rewrite plagiarism from the text yourself and then putting to some responsibility for both of these demanding jobs and providing you 100% unique content in the blink of an eye. There is plagiarism, but only some platforms will provide you with the quality Grammarin offers. This article is jam-packed with top-notch features to facilitate you in the best way possible. You can enjoy the following features.")
    this.char_count = $("#editor").text().length;
    this.word_count = $("#editor").text().trim().split(" ").length;
    this.showParagraph = false;
  }

  clearfeedbackform() {
    this.selectedValue = 0;
    $('#form_email').val('').css("border-color", "#e7e7ec");
    $('#form_message').val('').css("border-color", "#e7e7ec");
  }

  public PCroute() {
   
    this.editortxt = $("#editor").text();
    localStorage.setItem('editorValueAI', this.editortxt);
    const url = this.router.serializeUrl(this.router.createUrlTree(['/plagiarism-checker']));
    window.open(url, '_blank');
  }
  public gcrouteto() {
   
    this.editortxt = $("#editor").text();
    localStorage.setItem('editorValueAI', this.editortxt);
    const url = this.router.serializeUrl(this.router.createUrlTree(['']));
    window.open(url, '_blank');
  }
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const clipboardData = event.clipboardData;  
    const targetElement = event.target as HTMLElement;
   
    if ((targetElement.id === 'editor' || targetElement.closest('#editor')) && clipboardData && clipboardData.getData) {
      const pastedContent = clipboardData.getData('text/plain');
   
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
   
        if (!range.collapsed) {
     
          range.deleteContents();
          range.insertNode(document.createTextNode(pastedContent));
        } else {
        
          range.insertNode(document.createTextNode(pastedContent));
        }

        const newRange = document.createRange();
        newRange.selectNodeContents(range.endContainer);
        newRange.collapse(false); 
    
        selection.removeAllRanges();
        selection.addRange(newRange);
      }

  
      this.showParagraph = false;
      
      this.char_count = $("#editor").text().length;
      this.word_count = $("#editor").text().trim().split(/\s+/).length;
  
    }
  }

  public ngAfterViewInit(): void {
    //      const isMobile = window.innerWidth <= 768;

    // if (isMobile) {
    //   this.router.navigate(['/app-content-detector']);
    // } else {
    //   this.router.navigate(['/ai-content-detector']);
    // }
    
      this.screenWidth = window.innerWidth;
    this.textfromAI();
    this.getBrowserWidth();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
        $('#scroll-to-top').fadeIn('slow');
      }
      else {
        $('#scroll-to-top').fadeOut('slow');
      }
    });
    $('#scroll-to-top').click(function () {
      $("html, body").animate({ scrollTop: 0 }, 700);
      return false;
    });

    $("#editor").on("DOMSubtreeModified", function (change) {
      if (this.char_count === 0) {
        this.word_count = 0
      }
      this.char_count = $("#editor").text().length;
      this.word_count = $("#editor").text().trim().split(" ").length;
    });



  
    const element1 = document.getElementById('image1');
    const element2 = document.getElementById('image2');
    const element3 = document.getElementById('image3');


    function addTooltip(element: HTMLElement, tooltipText: string) {
      if (element) {
        element.addEventListener('mouseenter', function () {

          const existingTooltip = document.getElementById('custom-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }


          const tooltip = document.createElement('div');
          tooltip.id = 'custom-tooltip';
          tooltip.textContent = tooltipText;


          tooltip.style.visibility = 'hidden';
          tooltip.style.width = 'auto';
          tooltip.style.backgroundColor = '#08ba9c';
          tooltip.style.color = '#fff';
          tooltip.style.textAlign = 'center';
          tooltip.style.borderRadius = '6px';
          tooltip.style.padding = '8px';
          tooltip.style.position = 'absolute';
          tooltip.style.zIndex = '1000';
          tooltip.style.bottom = '125%';
          tooltip.style.left = '50%';
          tooltip.style.marginLeft = '-60px';
          tooltip.style.marginTop = '-10px';
          tooltip.style.opacity = '0';
          tooltip.style.height = '40px';
          tooltip.style.lineHeight = '24px';
          tooltip.style.transition = 'opacity .3s';


          const arrow = document.createElement('div');
          arrow.style.position = 'absolute';
          arrow.style.top = '100%';
          arrow.style.left = '50%';
          arrow.style.marginLeft = '-5px';
          arrow.style.borderWidth = '5px';
          arrow.style.borderStyle = 'solid';
          arrow.style.borderColor = '#08ba9c transparent transparent';


          tooltip.appendChild(arrow);


          const elementRect = element.getBoundingClientRect();
          tooltip.style.top = `${elementRect.top + window.scrollY - 35}px`;
          tooltip.style.left = `${elementRect.left + elementRect.width / 2 - tooltip.offsetWidth / 2}px`;


          document.body.appendChild(tooltip);


          setTimeout(() => {
            tooltip.style.visibility = 'visible';
            tooltip.style.opacity = '1';
          }, 10);


          element.addEventListener('mouseleave', function () {
            tooltip.style.visibility = 'hidden';
            tooltip.style.opacity = '0';
            setTimeout(() => {
              tooltip.remove();
            }, 300);
          });
        });
      }
    }


    addTooltip(element1, 'Upload from Your Computer');
    addTooltip(element2, 'Dropbox');
    addTooltip(element3, 'Google Drive');

  }

  public getBrowserWidth = function () {
  
    if (window.innerWidth <= 430) {
      this.mobilescreen = true;
      this.responseformodbile = false;
    
      return "xs";
    } else if (window.innerWidth < 991) {
      this.mobilescreen = false;
      this.responseformodbile = false;

      return "sm"
    } else if (window.innerWidth < 1199) {
      this.mobilescreen = false;
      this.responseformodbile = false
     
      return "md"
    } else {
      this.mobilescreen = false;
      this.responseformodbile = false;
     
      return "lg"
    }
  };
  public getContent(event, text) {

    var ctrlDown = false,
      ctrlKey = 17,
      cmdKey = 91,
      vKey = 86,
      cKey = 67;



    if (ctrlDown && event.keyCode == vKey) {
      this.showParagraph = false;
      var editortxt = $("#editor").text();
    }
 
    this.editortxt = $("#editor").text();


   
    this.char_count = $("#editor").text().length;
    this.word_count = $("#editor").text().trim().split(/\s+/).length;

  }

  public onclickeditor(event: MouseEvent) {
    event.stopPropagation(); 
    if (this.char_count === 0 && !this.showParagraph) {
      this.word_count = 0
      this.char_count = 0
    }
    this.showParagraph = false; 
    const sampleText = "Enter your Text HereORUpload file from above options";   
    const editorContent = $("#editor").text().trim();     
    if (editorContent === sampleText) {
      this.word_count = 0;
      this.char_count = 0;
    }
    if (editorContent === "" || editorContent === sampleText) {     
   
      this.word_count = 0;
      this.char_count = 0;
    } else {
      this.word_count = editorContent.split(/\s+/).filter(word => word.length > 0).length;
    }
  }
  @ViewChild('editor') editor!: ElementRef<HTMLDivElement>;
  @HostListener('document:click', ['$event.target'])
  onClickOutside(event) {
    const clickedElementId = event.id;
    var text = $('#editor').text();
    const excludedButtonIds = ['checkgrammar-btn-art', 'downloadfile', 'copy-btn', 'retry-btn', 'footerlinksforroute'];
    const editorContent = this.editor.nativeElement.innerText.trim();
    if (editorContent !== '') {
      return;
    }
    if (excludedButtonIds.includes(clickedElementId)) {
      return;
    }
    document.addEventListener('click', (event) => {  
      if (!this.editor.nativeElement.contains(event.target as Node)) { 
        if (!this.word_count || !this.char_count) {
          this.showParagraph = true;
        }
        else {
          this.showParagraph = false
        }
        this.word_count = 0;
        this.char_count = 0;
      
        const editorContent = $("#editor").text().trim();
        this.word_count = editorContent.split(/\s+/).filter(word => word.length > 0).length;
        this.char_count = editorContent.length;
      }
    });

  }
  checkairesponse() {

    if (!this.isCaptchaVerified) {
   
      return; 
    }

    if (this.showParagraph) {
      this.showAlert(" Enter 10 to 1000 words to Check AI Text Detector.", "");
      return
    }
    const editorContent = $('#editor').text().trim();

    const isPlaceholder =
      editorContent === "Upload Your Content" ||
      editorContent === "Type or Paste AI Text here";

    if (isPlaceholder || editorContent === "") {
      this.showAlert(" Enter 10 to 1000 words to Check AI Text Detector.", "");
      return;
    }


    if (this.word_count >= 10 && this.word_count <= 1000) {
      this.cleartxtbtn = true;
      this.editortxt = $('#editor').text()

      this.loaderAlert = true;
      if (this.mobilescreen) {
        this.responseformodbile = true;
      }
      else {
        this.responseformodbile = false;
      }
      this.gotresponse = false;
      this.human_score = 0;
      this.ai_score = 0;
      this.webservices.aidetectorapi(this.editortxt).subscribe(data => {
        this.gotresponse = true;
       
        this.human_score = data['human_score'];
        this.ai_score = data['ai_score'];
        this.loaderAlert = false;
        this.cleartxtbtn = false;
      });
    }
    else {
  
      this.showAlert(" Enter 10 to 1000 words to Check AI Text Detector.", "");
    }
  }



  showAlert(message, selector) {
    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts').show();
    setTimeout(() => {
      $('#errorAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false; 
  }



  public terriblevalue() {
    this.getterrible = true;
    this.badvalue = false;
    this.okayvalue = false;
    this.goodvalue = false;
    this.amzaingvalue = false;
  }

  public getbad() {
    this.badvalue = true;
    this.getterrible = false;
    this.okayvalue = false;
    this.goodvalue = false;
    this.amzaingvalue = false;
  }

  public gotokay() {
    this.okayvalue = true;
    this.goodvalue = false;
    this.badvalue = false;
    this.getterrible = false;
    this.amzaingvalue = false;
  }

  public gotgood() {
    this.goodvalue = true;
    this.badvalue = false;
    this.getterrible = false;
    this.okayvalue = false;
    this.amzaingvalue = false;
  }

  public amzaing() {
    this.amzaingvalue = true;
    this.goodvalue = false;
    this.badvalue = false;
    this.getterrible = false;
    this.okayvalue = false;
  }
  private resetValues() {
    this.getterrible = false;
    this.badvalue = false;
    this.okayvalue = false;
    this.goodvalue = false;
    this.amzaingvalue = false;
  }


  public sendfeedback() {
    this.eFsubIF = false;
    this.showmsg = false;
    var emotion = 'good';



    if (this.getterrible) {
      emotion = ''
      emotion = 'terrible'
    }
    if (this.badvalue) {
      emotion = ''
      emotion = 'bad'
    }
    if (this.goodvalue) {
      emotion = ''
      emotion = 'good'
    }
    if (this.okayvalue) {
      emotion = ''
      emotion = 'okay'
    }
    if (this.amzaingvalue) {
      emotion = ''
      emotion = 'amzaing'
    }
    if (this.feedbackValue === '') {
      this.showmsg = true;
  
      this.color = '#721c24';
      this.esubTextExp = 'Please provide the required fields';
      $('#feedid').val('').css("border-color", "red");
      $("#esubTextExp").show();
      setTimeout(function () {
        $("#esubTextExp").hide();
        $('#feedid').css("border-color", "#e7e7ec");
        this.showmsg = false;
      }, 3000);


    }
    else {
      this.showfeedbackloader = true;
      this.webservices.feedbackapi(emotion, this.feedbackValue).subscribe(data => {
        if (data) {
          this.showmsg = true;
          this.color = 'green';
          this.esubTextExp = 'Thank you for your feedback';
          this.showfeedbackloader = false;
          $("#esubTextExp").show();
          this.resetValues()
          this.feedbackValue = ''
          setTimeout(function () {
            this.esubText2Exp = ''
            $("#esubTextExp").hide();
            this.showmsg = false;
          }, 2000);
          $('#feedid').val('').css("border-color", "#e7e7ec");

        };
      })
    }

    this.eFsubIF = false;
  }

  ////////////// clear text function //////////
  public clear_txt() {
    var element = document.getElementById('editor');
    element.classList.remove('plag-editor-after');
    this.word_count = 0;
    this.char_count = 0;
    this.loaderAlert = false;
    this.showParagraph = true;
    this.human_score = 0;
    this.ai_score = 0;
    this.gotresponse = false;
    var testingnew = document.getElementById("editor");
    testingnew.textContent = '';
    this.showeditorplaceholder = false;

  }
  ////////////// Upload file function from browser //////////


  public uploadFileSaveRedirect(event): void {
  


    const files: FileList = this.fileInput.nativeElement.files;
  
    var filetype = "pdf";
    // this.loaderAlert = true;
    if (files[0].size > 5243000) {
    
      this.showAlert("File should be less than 5 MB", "");
    }
    else {
      let input = event.target;
  
      this.gotresponse = false;
      this.loaderAlert = true;
      this.showParagraph = false;
      var testingnew = document.getElementById("editor");
    
      if (testingnew.textContent != '') {
        testingnew.textContent = ''
        this.word_count = 0;
        this.char_count = 0;
        this.human_score = 0;
      }
      this.webservices.uploadfilefrombrowser(files).subscribe(
        (data => {
  
          this.loaderAlert = false;
         

          let receivedData = data;
          $("#editor").html(receivedData['RetCnt']);
          this.editortxt = receivedData['RetCnt']
          this.getContent('', receivedData['RetCnt'])
          this.fileInput.nativeElement.value = '';
          this.showParagraph = false;
     
        }
        ),
        (error) => {
          this.loaderAlert = false;
       
          this.showAlert("Unable to proceed with a password protected file", "");
        }
      )
    }
  }
  /////////// dropbox functionn////////
  openDropboxChooser(): void {

    const options = {
      success: (files: any) => {

        let fileType = this.getFileType(files[0].name);

        if (fileType === 'docx' || fileType === 'pdf' || fileType === 'txt') {
          this.uploadFileToServer(files[0].link, fileType);
        } else {
          // console.error('Unsupported file type');
        }
      },
      cancel: () => { },
      linkType: 'direct',
      multiselect: false,
      extensions: ['.docx', '.pdf', '.txt'],
      sizeLimit: 1024 * 1024 * 5
    };
    Dropbox.choose(options);

  }

  getFileType(fileName: string): string {

    const fileExtension = fileName.split('.').pop();
    return fileExtension ? fileExtension.toLowerCase() : '';
  }

  uploadFileToServer(fileLink: string, fileType: string): void {
  
    this.showParagraph = false;
    this.loaderAlert = true;
    this.webservices.dropboxfile(fileType, fileLink).subscribe(data => {

      let receivedData = data;
      $("#editor").html(receivedData['RetCnt']);
      this.getContent('', receivedData['RetCnt'])
      this.loaderAlert = false;
    })
  }
  ///////////////// google drive api///////////
 
  /// dropbox  gDriveUpload functionn////////
  public gDriveUpload() {
    gapi.load("auth", { callback: this.onAuthApiLoad.bind(this) });
    gapi.load("picker", { callback: this.onPickerApiLoad.bind(this) });
    const simulatedEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
    });

    this.onclickeditor(simulatedEvent);

    setTimeout(() => {
      const editorElement = $("#editor").get(0);
      if (editorElement) {
        const event = new KeyboardEvent('keydown', {
          key: '.',
          code: 'Period',
          keyCode: 190, 
          bubbles: true
        });

        editorElement.dispatchEvent(event);
      }
    }, 1000);
  }

  public onAuthApiLoad() {
    gapi.auth.authorize(
      {
        client_id: this.clientId,
        scope: this.scope,
        immediate: false,
      },
      this.handleAuthResult
    );
  }

  public onPickerApiLoad() {
    this.pickerApiLoaded = true;
  }
  isExport: boolean = false;
  public handleAuthResult(authResult) {
    $("#UpFileModal").modal("hide");
    let src;

    if (authResult && !authResult.error) {
      if (authResult.access_token) {
        let view = new google.picker.View(google.picker.ViewId.DOCS);
       
        view.setMimeTypes(
          "application/pdf,application/txt,text/plain,application/vnd.oasis.opendocument.text,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        );

        let pickerBuilder = new google.picker.PickerBuilder();
        let picker = pickerBuilder
          .enableFeature(google.picker.Feature.MINE_ONLY)
          .setOAuthToken(authResult.access_token)
          .addView(view)
          .addView(new google.picker.DocsUploadView())
          .setCallback(function (e) {
            if (e.action == google.picker.Action.PICKED) {
              var fileId = e.docs[0].id;
              var file = e.docs[0].url;
              var files = e.docs[0];
              if (files.sizeBytes > 5243000) {
                this.lodershow = false;
              
                swal({
                  background: "#FFFFFF",
                  title: "Error",
                  html: `
                  <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                    background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                    <div class="text-center" style="margin-top: 9%;">
                      <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                      <div style="width: 323px; height: 64px; margin-left: 77px;">
                        <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                          File should be less than 5 MB
                        </p>
                      </div>
                      <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                        border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                        class="mt-4 butn-alert">Ok</button>
                    </div>
                  </div>
                `,
                  showConfirmButton: false,
                  width: "323px",
                  timer: 4000
                });

             
                setTimeout(() => {
                  const okButton = document.getElementById('swal-ok-button');
                  if (okButton) {
                    okButton.addEventListener('click', () => {
                      swal.close(); 
                    });
                  }
                }, 0);
              }
              else {
                if (e.docs[0].name.split(".")[1] === "pdf") {

                
                  let filelink2 = file + fileId;
                  let linksvalue =
                    "https://drive.google.com/u/0/uc?id=" +
                    fileId +
                    "&export=download";
                  if (localStorage.getItem("profile_id")) {
                    var profile_id = localStorage.getItem("profile_id");
                  } else {
                    var profile_id = "1";
                  }
                  $.ajax({
                    url: environment.API_URL + "/api/downloadFromDrive",
                    type: "post",
               
                    dataType: "json",
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: "pdf",
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        "Authorization",
                        +localStorage.getItem("token")
                      );
                    },

                    success: function (return_data) {
                      $("#editor").html(return_data.RetCnt);
                      this.showParagraph = false;

                      const Characters = $("#editor").text().length;
                      const words = $("#editor").text().trim().split(/\s+/).filter(word => word.length > 0).length;

                 
         
                      let data2 = JSON.stringify({
                        homeText: return_data.RetCnt,
                        profile_id: profile_id
                      });
                      const simulatedEvent = new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                      });
                    
                      this.onclickeditor(simulatedEvent);

                      setTimeout(() => {
                        const editorElement = $("#editor").get(0);
                        if (editorElement) {
                          const event = new KeyboardEvent('keydown', {
                            key: '.',
                            code: 'Period',
                            keyCode: 190, 
                            bubbles: true
                          });

                          editorElement.dispatchEvent(event);
                        }
                      }, 1000);

                  

                    },
                    error: function (data) {
                      
                      swal({
                        background: "#FFFFFF",
                        title: "Error",
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: "323px",
                        timer: 4000
                      });


       
                      setTimeout(() => {
                        const okButton = document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close(); 
                          });
                        }
                      }, 0);

                    }
                  });
                } else if (e.docs[0].name.split(".")[1] === "txt") {
                 
                  let filelink2 = file + fileId;
                  let linksvalue =
                    "https://drive.google.com/u/0/uc?id=" +
                    fileId +
                    "&export=download";

                  if (localStorage.getItem("profile_id")) {
                    var profile_id = localStorage.getItem("profile_id");
                  } else {
                    var profile_id = "1";
                  }
                  $.ajax({
                    url: environment.API_URL + "/api/downloadFromDrive",
                    type: "post",
                 
                    dataType: "json",
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: "txt",
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        "Authorization",
                        +localStorage.getItem("token")
                      );
                    },

                    success: function (return_data) {
                      $("#editor").html(return_data.RetCnt);

                      this.hideothers = true;

                      const Characters = $("#editor").text().length;
                      const words = $("#editor").text().trim().split(/\s+/).filter(word => word.length > 0).length;

                    
                      let data2 = JSON.stringify({
                        homeText: return_data.RetCnt,
                        profile_id: profile_id
                      });
                      const simulatedEvent = new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                      });
                
                      this.onclickeditor(simulatedEvent);

                      setTimeout(() => {
                        const editorElement = $("#editor").get(0);
                        if (editorElement) {
                          const event = new KeyboardEvent('keydown', {
                            key: '.',
                            code: 'Period',
                            keyCode: 190, 
                            bubbles: true
                          });

                          editorElement.dispatchEvent(event);
                        }
                      }, 1000);
                   

                    },
                    error: function (data) {
                   
                      swal({
                        background: "#FFFFFF",
                        title: "Error",
                        html: `
                      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                        <div class="text-center" style="margin-top: 9%;">
                          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                          <div style="    width: 369px; height: 64px; margin-left: 39px;">
                            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
                            </p>
                          </div>
                          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                            class="mt-5 butn-alert">Ok</button>
                        </div>
                      </div>
                    `,
                        showConfirmButton: false,
                        width: "323px",
                        timer: 4000
                      });


                     
                      setTimeout(() => {
                        const okButton = document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close(); 
                          });
                        }
                      }, 0);

                    }
                  });
                } else if (e.docs[0].name) {
               
                  let filelink2 = file + fileId;
                  let linksvalue =
                    "https://docs.google.com/feeds/download/documents/export/Export?id=" +
                    fileId +
                    "&exportFormat=docx";
                  if (localStorage.getItem("profile_id")) {
                    var profile_id = localStorage.getItem("profile_id");
                  } else {
                    var profile_id = "1";
                  }
                  $.ajax({
                    url: environment.API_URL + "/api/downloadFromDrive",
                    type: "post",
                
                    dataType: "json",
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: "docx",
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        "Authorization",
                        +localStorage.getItem("token")
                      );
                    },

                    success: function (return_data) {
                      $("#editor").html(return_data.RetCnt);
                      this.showParagraph = false;

                      const Characters = $("#editor").text().length;
                      const words = $("#editor").text().trim().split(/\s+/).filter(word => word.length > 0).length;

                   
                      let data2 = JSON.stringify({
                        homeText: return_data.RetCnt,
                        profile_id: profile_id
                      });
                      const simulatedEvent = new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                      });
          
                      this.onclickeditor(simulatedEvent);

                      setTimeout(() => {
                        const editorElement = $("#editor").get(0);
                        if (editorElement) {
                          const event = new KeyboardEvent('keydown', {
                            key: '.',
                            code: 'Period',
                            keyCode: 190, 
                            bubbles: true
                          });

                          editorElement.dispatchEvent(event);
                        }
                      }, 1000);
                     

                    },
                    error: function (data) {
                      
                      swal({
                        background: "#FFFFFF",
                        title: "Error",
                        html: `
                      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                        <div class="text-center" style="margin-top: 9%;">
                          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                          <div style="    width: 369px; height: 64px; margin-left: 39px;">
                            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
                            </p>
                          </div>
                          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                            class="mt-5 butn-alert">Ok</button>
                        </div>
                      </div>
                    `,
                        showConfirmButton: false,
                        width: "323px",
                        timer: 4000
                      });


                 
                      setTimeout(() => {
                        const okButton = document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close(); 
                          });
                        }
                      }, 0);

                    }
                  });
                }
              }
            }
          })
          .build();
        picker.setVisible(true);
      }
    }
    const simulatedEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
    });
 
    this.onclickeditor(simulatedEvent);

    setTimeout(() => {
      const editorElement = $("#editor").get(0);
      if (editorElement) {
        const event = new KeyboardEvent('keydown', {
          key: '.',
          code: 'Period',
          keyCode: 190, 
          bubbles: true
        });

        editorElement.dispatchEvent(event);
      }
    }, 1000);
  }

  @ViewChild('editor') textDivRef!: ElementRef;
  deleteText() {
    this.loaderAlert = true;
    if (this.textDivRef) {
      this.loaderAlert = true;
      this.textDivRef.nativeElement.innerHTML = '';
    }
 
    this.word_count = 0;
    this.char_count = 0;
    this.loaderAlert = false;
    this.showParagraph = true;
    this.gotresponse = false;
    this.ai_score = 0;
    this.human_score = 0;
  }

  //  objects objects objects

  executeAction(action: string) {
    if (this[action] && typeof this[action] === 'function') {
      this[action]();
    } else {
      // console.error(`Action "${action}" is not a valid method.`);
    }
  }

  contentArray = [
    {
      showParagraph: true,
      header: 'Upload Your Content',
      paragraph: 'Type or Paste AI Text here',
      buttons: [
        {
          text: 'Sample Text',
          icon: 'copyIcon',
          action: 'sampletext'
        },
        {
          text: 'Paste Text',
          icon: 'copyIcon',
          action: 'pasteText'
        }

      ]
    }
  ];

  //  for result scetion hide or display 
  radius: number = 55;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    const window = event.target as Window;
    this.screenWidth = window.innerWidth;
  }
  screenWidth: number;

  get circleProgressRadius() {
    if (this.screenWidth <= 991) {
      return 30; 
    } 
    // else if (this.screenWidth >= 768 && this.screenWidth < 1024) {
    //   return 50; 
    // }
     else {
      return 60; 
    }
  }
    //  for result scetion hide or display
}
